/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamDetailsAliases {
  CARD_EXAMS_ESTABLISHMENT_INFORMATION_0 = 'card-exams-establishment-information-0',
  CARD_EXAMS_INFORMATION_0 = 'card-exams-information-0',
  CARD_EXAMS_LIST_ITEM = 'card-exams-list-item',
  CARD_EXAMS_TITLE_0 = 'card-exams-title-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_EXAMS = 'deck-exams',
  DOWNLOAD_EXAM_BTN = 'download-exam-btn',
  FETCH_EXAM_DETAILS = 'fetch-exam-details',
  FETCH_EXAMS = 'fetch-exams',
  FRAGMENT_0 = 'fragment-0',
  INFORMATION_BAR = 'information-bar',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_EXAM_DETAILS = 'layout-exam-details',
  LAYOUT_REPORT = 'layout-report',
  LOADER_DETAILS_1 = 'loader-details-1',
  LOADER_DETAILS_2 = 'loader-details-2',
  LOADER_ESTABLISHMENT = 'loader-establishment',
  LOADER_REPORT = 'loader-report',
  PAC_BTN = 'pac-btn',
  PANEL_EXAM_CARD = 'panel-exam-card',
  PANEL_EXAM_LEFT_CARD = 'panel-exam-left-card',
  PANEL_EXAM_LIST = 'panel-exam-list',
  PANEL_EXAM_RIGHT_CARD = 'panel-exam-right-card',
  PANEL_EXAM_TITLE = 'panel-exam-title',
  PANEL_LOADER_DETAILS_1 = 'panel-loader-details-1',
  PANEL_LOADER_DETAILS_2 = 'panel-loader-details-2',
  PANEL_LOADER_ESTABLISHMENT = 'panel-loader-establishment',
  PANEL_LOADER_REPORT = 'panel-loader-report',
  PANEL_MESSAGE = 'panel-message',
  PANEL_REPORT = 'panel-report',
  PANEL_TITLE = 'panel-title',
  PANEL_TITLE_LIST = 'panel-title-list',
  PDF_VIEWER_EXAM_DETAILS = 'pdf-viewer-exam-details',
  ROUTE_0 = 'route-0',
  TEXT_0 = 'text-0',
  TEXT_TITLE_LIST = 'text-title-list',
}
export { ExamDetailsAliases };
